module.exports = __webpack_public_path__ + "static/media/image_Chats_ICON.46bbcac1.svg";